export type ProductKeyTypes =
    | "confluence"
    | "confluence-PaidLpConflDocumentation"
    | "confluence-PaidLpConflFeatures"
    | "confluence-PaidLpConflFeaturesCerebro"
    | "confluence-PaidLpConflTemplate"
    | "confluence-AnchorLpConfCollaboration"
    | "home"
    | "jira"
    | "jiraServiceDesk"
    | "jiraServiceManagement"
    | "jiraProductDiscovery"
    | "jiraServiceManagement-PaidLpJsmFeatures"
    | "jiraServiceManagement-PaidLpJsmFeaturesCerebro"
    | "jiraServiceManagement-PaidLpJsmIncidentChangeMgmt"
    | "jiraServiceManagement-PaidLpJsmItsm"
    | "jiraServiceManagement-PaidLpJsmServiceDesk"
    | "jiraServiceManagement-PaidLpJsmTicketing"
    | "jiraServiceManagement-AnchorLpJsmAsset"
    | "jiraServiceManagement-AnchorLpJsmDevops"
    | "jiraSoftware"
    | "jiraSoftware-PaidLpJiraFeatures"
    | "jiraSoftware-PaidLpJiraPm"
    | "jiraSoftware-PaidLpJiraRoadmaps"
    | "jiraSoftware-PaidLpJiraTemplate"
    | "jiraSoftware-PaidLpJiraTracker"
    | "jiraSoftwareFeature"
    | "try";

type CommonComponentsTypes =
    | "linkButton"
    | "tab"
    | "card"
    | "carouselItem"
    | "link";

type CommonContainersTypes =
    | "navbarDropdown"
    | "navbar"
    | "globalNavWacDropdownContainer"
    | "heroSection"
    | "cardSection"
    | "ctaSection"
    | "announcementBanner"
    | "priceBlock"
    | "priceBlockDropdownLocalized"
    | "infographicsSection"
    | "freeBundles"
    | "customersSection"
    | "getTheMostSection";

type CommonEventTypes = "clicked" | "hovered" | "loading";

type JSWContainerTypes =
    | CommonContainersTypes
    | "featuresSection"
    | "benefitsSection"
    | "banner-link-button"
    | "priceBlock"
    | "pricingQuiz"
    | "priceBlockDropdownLocalized"
    | "devOpsSection"
    | "integrationSection"
    | "workflowSection"
    | "timelineSection"
    | "reportsAndInsightsSection"
    | "dragAndDropSection";

type JSMContainerTypes =
    | CommonContainersTypes
    | "benefitsSection"
    | "featuresSection"
    | "integrationsSection"
    | "videoEmbedInline"
    | "linkButton"
    | "videoLink";

type ConfluenceContainerTypes =
    | CommonContainersTypes
    | "priceBlock"
    | "featuresSection"
    | "benefitsSection"
    | "additionalResourcesSection"
    | "videoEmbedInline"
    | "videoLink"
    | "integrationsSection"
    | "mobileSection"
    | "resourcesSection"
    | "templatesSection"
    | "templatesTabCard"
    | "testimonialsSection";

export type DataEventProps =
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              | "confluence"
              | "confluence-PaidLpConflDocumentation"
              | "confluence-PaidLpConflFeatures"
              | "confluence-PaidLpConflTemplate"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": ConfluenceContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              "home" | "jiraSoftware-PaidLpJiraFeatures" | "jira" | "try"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              "jiraSoftware" | "jiraSoftwareFeature"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSWContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceDesk">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceManagement">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": ProductKeyTypes;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      };
